.spectatorIconWrapper {
  position: relative;

  & .spectatorIconNotification {
    pointer-events: none;
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    top: 19px;
    right: 5px;
    background-color: var(--ds-red-dark);
    font-size: 12px;
    line-height: 12px;
    color: white;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
  }
}

.spectatorIcon {
  cursor: pointer;

  &:hover {
    filter: drop-shadow(0px 1px 3px rgba(50, 50, 0, 0.2));
  }
}

.spectatorMenuWrapper {
  position: absolute;
  z-index: 1;
  top: calc(100% + 2px);
  right: 0;
  background-color: var(--ds-off-white);

  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;

  padding: 6px 8px;
  border-radius: 4px;

  & .centered {
    align-self: center;
  }
}

.spectatorLists {
  position: relative;

  & .divider {
    position: absolute;
    left: 40px;
    width: 3px;
    height: 100%;
    border-right: 1px solid var(--ds-grey-dark);
  }
}

.spectatorListWrapper {
  display: flex;
  flex-flow: row nowrap;

  &:not(.mySpectators) {
    margin-top: 8px;
    align-items: center;
  }

  & .spectatorList {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    & > div {
      margin-left: 6px;
    }
  }
}

.spectatorListButtons {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  & :focus {
    outline: none;
  }
}

.gravatarTooltipWrapper {
  position: relative;
}

.gravatarTooltipWrapper:hover img {
  filter: drop-shadow(0px 2px 6px rgba(255, 255, 255, 0.3));
}

.gravatarTooltipBubble {
  border-radius: 4px;
  left: 45%;
  bottom: calc(100% + 4px);
}

.gravatarTooltipText {
  /* safari needed this here instead of in .x-tooltip-bubble to prevent text wrapping for some reason
    maybe safari doesn't use the padding width to calculate `width: max-content`?
  */
  padding: 2px 12px;
}
